export default function Contact() {
	return (
		<div className="container py-12">
			<h1 className="text-3xl font-bold">Contact</h1>
			<p className="mt-4 text-gray-600">
				Headquarters: 575 S 143rd Ave, Unit 08, Goodyear, AZ 85338
			</p>
			<p className="mt-2 text-gray-600">Email: support@ubiquityglass.com</p>
		</div>
	);
}
